// fetchMediaMenifestOfMessage.js
// TODO: change menifest to manifest
'use strict';
import getMessageData from '../selector/getMessageData.js';
import getAssetData from '../selector/getAssetData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import fetchMediaMenifest from '../resource/fetchMediaMenifest.js';
import trackEvent from '../resource/mixpanel.js';
import { EventTypes } from '../resource/trackingConstants.js';
import {
  ADD_MESSAGE,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

const AES_MANIFEST_TYPE = 'm3u8';
const DRM_MANIFEST_TYPE = 'mpd';

const getAesManifestData = ({ assetContentType, duration }) => {
  if (!assetContentType) {
    throw new Error('aes_menifest_error');
  }
  const mediaType = assetContentType.split('/')[0];
  const manifestMedia = duration ? { mediaType, duration } : { mediaType };
  return {
    menifestType: AES_MANIFEST_TYPE,
    menifest: {
      [AES_MANIFEST_TYPE]: manifestMedia,
    },
  };
};

const fetchDrmManifestData = async ({ id, assetId }) => {
  const menifest = await fetchMediaMenifest({
    id,
    assetId,
    type: DRM_MANIFEST_TYPE,
  });
  if (!menifest) {
    throw new Error('drm_parse_menifest_error');
  }
  return {
    menifestType: DRM_MANIFEST_TYPE,
    menifest,
  };
};

/**
 * Fetch media menifest of message
 * @kind action
 * @param {string} {id} - action param.
 * @return {Promise} Action promise.
 */
const fetchMediaMenifestOfMessage =
  ({ id }) =>
  async (dispatch, getState) => {
    const selectPath = ['messages', id, 'media', 'menifest'];
    const isFetched = getNetworkingData(getState(), selectPath, 'isFetched');
    const isFetching = getNetworkingData(getState(), selectPath, 'isFetching');
    const error = getNetworkingData(getState(), selectPath, 'error');
    if (isFetching || (isFetched && !error)) {
      return dispatch({ type: '' });
    }
    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    const assetId = getMessageData(getState(), id, 'assetIds')?.[0];
    const isAesEncrypted = getAssetData(getState(), [assetId], 'aes');
    const assetContentType = getAssetData(getState(), [assetId], 'contentType');

    let menifestData = null;
    try {
      if (isAesEncrypted) {
        menifestData = getAesManifestData({
          assetContentType,
          duration: getAssetData(getState(), [assetId], 'duration'),
        });
      } else {
        menifestData = await fetchDrmManifestData({ id, assetId });
      }
      if (!menifestData) {
        throw new Error('parse_menifest_error');
      }
    } catch (error) {
      trackEvent({
        type: EventTypes.PLAYER_ERROR,
        payload: {
          messageId: id,
          errorReason: 'media-manifest-failed',
          errorMessage: error?.message ?? null,
          httpStatus: error?.httpStatus ?? null,
          failedUri: error?.failedUri ?? null,
          isErrorUndefined: error == null,
        },
      });
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { error, selectPath },
      });
    }

    const { menifestType, menifest } = menifestData || {};
    const manifestMedia = menifest?.[menifestType];
    const mediaType = manifestMedia?.mediaType || null;
    const duration = manifestMedia?.duration;
    const media = duration
      ? { type: mediaType, duration }
      : { type: mediaType };
    dispatch({
      type: ADD_MESSAGE,
      payload: {
        id,
        media,
        menifestType,
        menifest,
      },
    });
    return dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
  };

export default fetchMediaMenifestOfMessage;
